export default __webpack_public_path__ + "static/media/logo-white.638133ce.svg";